/**
 * La GÉOMÉTRIE du radar : sommets d'un polygone régulier, anneaux de grille,
 * découpe des intitulés.
 *
 * Fichier séparé du composant : un `.jsx` qui exporte autre chose qu'un
 * composant casse le Fast Refresh de Vite, et l'écran part blanc sans erreur.
 */

export const WIDTH = 600
export const HEIGHT = 390
export const CX = 300
export const CY = 195
export const R = 126
export const LABEL_GAP = 30
export const WRAP_AT = 14

/** Le sommet d'index `i` sur `n` axes, à la distance `r` du centre. */
export const vertex = (i, n, r) => {
  const angle = -Math.PI / 2 + (i * 2 * Math.PI) / n
  return [CX + Math.cos(angle) * r, CY + Math.sin(angle) * r]
}

export const polygon = (n, r) =>
  Array.from({ length: n }, (_, i) => vertex(i, n, r).map((v) => v.toFixed(1)).join(',')).join(' ')

/** Découpe un intitulé en lignes d'environ `WRAP_AT` caractères. */
export const wrapLabel = (text, at = WRAP_AT) => {
  const lines = []
  let current = ''
  String(text ?? '')
    .split(' ')
    .forEach((word) => {
      if (!current) current = word
      else if (`${current} ${word}`.length <= at) current += ` ${word}`
      else { lines.push(current); current = word }
    })
  if (current) lines.push(current)
  return lines
}

export const clampRatio = (v) => {
  const n = Number(v)
  if (!Number.isFinite(n)) return 0
  return Math.min(Math.max(n, 0), 1)
}
